import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

import { Localize } from "components/service";

const TotalItems = ({
    titleKey = "GLOBAL.Text_GraphicCount",
    pageInfo = null
}) => {

    // Show the total number of items
    const displayTotal = pageInfo ? pageInfo.total : 0;

    return (
        <div
            color="default"
            style={ {
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '16px',
                border: 'none',
                fontWeight: '600',
                color: 'white',
                textTransform: 'capitalize',
                // marginBottom: '16px',
                lineHeight: '1.4'
            } }
        >
            <Localize>{ titleKey }</Localize>: <span style={ { fontWeight: '700' } }><span style={ { color: '#f8dc00' } }>{ pageInfo ? displayTotal : <LoadingOutlined /> }</span></span>
        </div>
    );
}

export default TotalItems;